import { render } from "./TrameFront.vue?vue&type=template&id=ae7cb5ec&scoped=true"
import script from "./TrameFront.vue?vue&type=script&lang=js"
export * from "./TrameFront.vue?vue&type=script&lang=js"

import "./TrameFront.vue?vue&type=style&index=0&id=ae7cb5ec&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7cb5ec"]])

export default __exports__